/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Recentactivity_Newuserregistered3Inputs */

const he_dashboard_recentactivity_newuserregistered3 = /** @type {(inputs: Dashboard_Recentactivity_Newuserregistered3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`משתמש חדש נרשם`)
};

const en_dashboard_recentactivity_newuserregistered3 = /** @type {(inputs: Dashboard_Recentactivity_Newuserregistered3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New user registered`)
};

/**
* | output |
* | --- |
* | "New user registered" |
*
* @param {Dashboard_Recentactivity_Newuserregistered3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const dashboard_recentactivity_newuserregistered3 = /** @type {((inputs?: Dashboard_Recentactivity_Newuserregistered3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Recentactivity_Newuserregistered3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_recentactivity_newuserregistered3(inputs)
	return en_dashboard_recentactivity_newuserregistered3(inputs)
});
export { dashboard_recentactivity_newuserregistered3 as "dashboard_recentActivity_newUserRegistered" }